// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeUploader-space1-XZyBn {
	margin-bottom: 6px !important;
}

.HomeUploader-space2-UpgV8 {
	margin-bottom: 12px !important;
}

.HomeUploader-space3-YLKNN {
	margin-bottom: 18px !important;
}

.HomeUploader-space4-ijYcB {
	margin-bottom: 24px !important;
}

.HomeUploader-space5-gNfri {
	margin-bottom: 30px !important;
}

.HomeUploader-space6-uiEiq {
	margin-bottom: 36px !important;
}

.HomeUploader-space7-BZEnf {
	margin-bottom: 42px !important;
}

.HomeUploader-spaceTop8-XPvby {
	margin-bottom: 48px !important;
}

.HomeUploader-spaceTop1-wCRnr {
	margin-top: 6px !important;
}

.HomeUploader-spaceTop2-jwvO0 {
	margin-top: 12px !important;
}

.HomeUploader-spaceTop3-Bn9NA {
	margin-top: 18px !important;
}

.HomeUploader-spaceTop4-obAWe {
	margin-top: 24px !important;
}

.HomeUploader-spaceTop5-Hvlf6 {
	margin-top: 30px !important;
}

.HomeUploader-spaceTop6-j4bxQ {
	margin-top: 36px !important;
}

.HomeUploader-spaceTop7-lVaax {
	margin-top: 42px !important;
}

.HomeUploader-spaceTop8-XPvby {
	margin-top: 48px !important;
}

.HomeUploader-noMargin-M9Ap_ {
	margin: 0px !important;
}

.HomeUploader-padding1-HQFyD {
	padding-bottom: 6px !important;
}

.HomeUploader-padding2-Py1j5 {
	padding-bottom: 12px !important;
}

.HomeUploader-padding3-xlb4W {
	padding-bottom: 18px !important;
}

.HomeUploader-padding4-ENhuH {
	padding-bottom: 24px !important;
}

.HomeUploader-padding5-X8Mrs {
	padding-bottom: 30px !important;
}

.HomeUploader-padding6-mbMTR {
	padding-bottom: 36px !important;
}

.HomeUploader-padding7-tG47q {
	padding-bottom: 42px !important;
}

.HomeUploader-paddingTop1-QfD0s {
	padding-top: 6px !important;
}

.HomeUploader-paddingTop2-mnO5G {
	padding-top: 12px !important;
}

.HomeUploader-paddingTop3-k0sa3 {
	padding-top: 18px !important;
}

.HomeUploader-paddingTop4-MI0Z7 {
	padding-top: 24px !important;
}

.HomeUploader-paddingTop5-dPKKd {
	padding-top: 30px !important;
}

.HomeUploader-paddingTop6-rfd03 {
	padding-top: 36px !important;
}

.HomeUploader-paddingTop7-bwQNq {
	padding-top: 42px !important;
}

.HomeUploader-noPadding-bbOy3 {
	padding: 0px !important;
}

.HomeUploader-textBold-IJt5K {
	font-weight: 500 !important;
}

.HomeUploader-textBolder-_9Xer {
	font-weight: 700 !important;
}

.HomeUploader-textNormal-BjO0s {
	font-weight: normal !important;
}

.HomeUploader-spaceBottom20-AXPpb {
	margin-bottom: 20px;
}

.HomeUploader-spaceBottom10-Xtcgn {
	margin-bottom: 10px;
}

.HomeUploader-marginNone-pY0qr {
	margin: 0;
}

.HomeUploader-spaceBottom15-sb9fR {
	margin-bottom: 15px;
}

.HomeUploader-marginTopNone-ECibh {
	margin-top: 0;
}

.HomeUploader-spaceTop11-Nq62c {
	margin-top: 11px;
}

.HomeUploader-spaceTop21-jjr2H {
	margin-top: 21px;
}

.HomeUploader-spaceTop20-wXAcj {
	margin-top: 20px;
}

.HomeUploader-spaceTop10-Wupil {
	margin-top: 10px;
}

/*New Design Text Colors */

.HomeUploader-textDarkBlue-RNqUM {
	color: rgb(20, 39, 94) !important;
}

.HomeUploader-textLightBlue-AzK6D {
	color: rgb(57, 87, 106) !important;
}

.HomeUploader-textLightSandleGreen-RLNCq {
	color: rgb(76, 86, 41) !important;
}

.HomeUploader-textLightBrown-F7bT8 {
	color: rgb(115, 79, 33) !important;
}

.HomeUploader-textMediumMaroon-cwQu9 {
	color: rgb(87, 37, 51) !important;
}

.HomeUploader-textBrown-h9YM6 {
	color: rgb(160, 47, 24) !important;
}

.HomeUploader-textMaroon-IIxMf {
	color: rgb(155, 49, 67) !important;
}

.HomeUploader-textDarkBrown-vQBl7 {
	color: rgb(83, 18, 16) !important;
}

.HomeUploader-textMediumBrown-O3S6m {
	color: rgb(142, 28, 10) !important;
}

.HomeUploader-textSkyBlue-GTM4V {
	color: rgb(37, 117, 141) !important;
}

.HomeUploader-textGray-fyc8e {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `HomeUploader-space1-XZyBn`,
	"space2": `HomeUploader-space2-UpgV8`,
	"space3": `HomeUploader-space3-YLKNN`,
	"space4": `HomeUploader-space4-ijYcB`,
	"space5": `HomeUploader-space5-gNfri`,
	"space6": `HomeUploader-space6-uiEiq`,
	"space7": `HomeUploader-space7-BZEnf`,
	"spaceTop8": `HomeUploader-spaceTop8-XPvby`,
	"spaceTop1": `HomeUploader-spaceTop1-wCRnr`,
	"spaceTop2": `HomeUploader-spaceTop2-jwvO0`,
	"spaceTop3": `HomeUploader-spaceTop3-Bn9NA`,
	"spaceTop4": `HomeUploader-spaceTop4-obAWe`,
	"spaceTop5": `HomeUploader-spaceTop5-Hvlf6`,
	"spaceTop6": `HomeUploader-spaceTop6-j4bxQ`,
	"spaceTop7": `HomeUploader-spaceTop7-lVaax`,
	"noMargin": `HomeUploader-noMargin-M9Ap_`,
	"padding1": `HomeUploader-padding1-HQFyD`,
	"padding2": `HomeUploader-padding2-Py1j5`,
	"padding3": `HomeUploader-padding3-xlb4W`,
	"padding4": `HomeUploader-padding4-ENhuH`,
	"padding5": `HomeUploader-padding5-X8Mrs`,
	"padding6": `HomeUploader-padding6-mbMTR`,
	"padding7": `HomeUploader-padding7-tG47q`,
	"paddingTop1": `HomeUploader-paddingTop1-QfD0s`,
	"paddingTop2": `HomeUploader-paddingTop2-mnO5G`,
	"paddingTop3": `HomeUploader-paddingTop3-k0sa3`,
	"paddingTop4": `HomeUploader-paddingTop4-MI0Z7`,
	"paddingTop5": `HomeUploader-paddingTop5-dPKKd`,
	"paddingTop6": `HomeUploader-paddingTop6-rfd03`,
	"paddingTop7": `HomeUploader-paddingTop7-bwQNq`,
	"noPadding": `HomeUploader-noPadding-bbOy3`,
	"textBold": `HomeUploader-textBold-IJt5K`,
	"textBolder": `HomeUploader-textBolder-_9Xer`,
	"textNormal": `HomeUploader-textNormal-BjO0s`,
	"spaceBottom20": `HomeUploader-spaceBottom20-AXPpb`,
	"spaceBottom10": `HomeUploader-spaceBottom10-Xtcgn`,
	"marginNone": `HomeUploader-marginNone-pY0qr`,
	"spaceBottom15": `HomeUploader-spaceBottom15-sb9fR`,
	"marginTopNone": `HomeUploader-marginTopNone-ECibh`,
	"spaceTop11": `HomeUploader-spaceTop11-Nq62c`,
	"spaceTop21": `HomeUploader-spaceTop21-jjr2H`,
	"spaceTop20": `HomeUploader-spaceTop20-wXAcj`,
	"spaceTop10": `HomeUploader-spaceTop10-Wupil`,
	"textDarkBlue": `HomeUploader-textDarkBlue-RNqUM`,
	"textLightBlue": `HomeUploader-textLightBlue-AzK6D`,
	"textLightSandleGreen": `HomeUploader-textLightSandleGreen-RLNCq`,
	"textLightBrown": `HomeUploader-textLightBrown-F7bT8`,
	"textMediumMaroon": `HomeUploader-textMediumMaroon-cwQu9`,
	"textBrown": `HomeUploader-textBrown-h9YM6`,
	"textMaroon": `HomeUploader-textMaroon-IIxMf`,
	"textDarkBrown": `HomeUploader-textDarkBrown-vQBl7`,
	"textMediumBrown": `HomeUploader-textMediumBrown-O3S6m`,
	"textSkyBlue": `HomeUploader-textSkyBlue-GTM4V`,
	"textGray": `HomeUploader-textGray-fyc8e`
};
module.exports = ___CSS_LOADER_EXPORT___;
